export default typeof window === 'undefined'
  ? () => null : () => window.location.href;
